var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 31,
    viewBox: "0 0 13 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.402344,
    width: 13,
    height: 3.49115,
    fill: "#1C3A77"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9.12988,
    width: 7.22222,
    height: 3.49115,
    fill: "#1C3A77"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 26.5859,
    width: 7.22222,
    height: 3.49115,
    fill: "#1C3A77"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 17.8584,
    width: 13,
    height: 3.49115,
    fill: "#1C3A77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon);
export default __webpack_public_path__ + "static/media/toggle-icon.faad9adc9275b66d180891d501199c6d.svg";
export { ForwardRef as ReactComponent };